import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import TypicalCosts from '@/components/molecules/de-uni/typical-costs/typical-costs';
import EntryRequirements from '@/components/molecules/de-uni/entry-requirements/entry-requirements';
import ICostsAndEntryRequirements from '@/models/viewModels/ICostsAndEntryRequirements';
import AcYearCostsBreakdown from '@/components/molecules/de-uni/typical-costs-acyear-breakdown/typical-costs-acyear-breakdown';
import Scholarships from '@/components/molecules/de-uni/scholarships/scholarships';
import styles from './costs-and-entry-reqs.module.scss';

type Props = {
  costsAndEntryRequirements: ICostsAndEntryRequirements[];
  universityPrimaryColor: string;
};

export default function CostsAndEntryReqs({
  costsAndEntryRequirements,
  universityPrimaryColor,
}: Props) {
  return (
    <section className="mt-5" id="costs-entry-reqs">
      <h2>Costs and Entry Requirements</h2>
      <div className="tab-content-block">
        <Tabs defaultActiveKey="0" className="mt-0">
          {costsAndEntryRequirements.map((el, i) => (
            <Tab key={el.tabName} eventKey={i.toString()} title={el.tabName}>
              {el.typicalCostsIntro && <TypicalCosts typicalCostsIntro={el.typicalCostsIntro} />}
              <div
                id={`breakdown-acyr-main-${i.toString()}-${el.tabName}`}
                className={`${styles[`cost-breakdown-section`]} w-100`}
              >
                <div id={`breakdown-acyr-row-${i.toString()}-${el.tabName}`} className="row">
                  {el.typicalCostsBreakdown?.length ? (
                    <div
                      id={`breakdown-acyr-col1-${i.toString()}-${el.tabName}`}
                      className="col-lg-8"
                    >
                      <AcYearCostsBreakdown
                        acYearCostsBreakdown={el.typicalCostsBreakdown}
                        programType={el.tabName}
                      />
                    </div>
                  ) : null}
                  {el.scholarship?.url?.length && (
                    <div
                      id={`breakdown-acyr-breakdown-col2-${i.toString()}-${el.tabName}`}
                      className={`${
                        el.typicalCostsBreakdown?.length ? styles[`has-cost-section`] : `col-lg-4`
                      } col`}
                    >
                      <Scholarships
                        scholarship={el.scholarship}
                        programType={el.tabName}
                        brandColor={universityPrimaryColor}
                      />
                    </div>
                  )}
                </div>
              </div>
              <EntryRequirements
                entryReqs={el.entryRequirements.intro}
                academicEntryReqs={el.entryRequirements.academicRequirements}
                englishLanguageReqs={el.entryRequirements.englishLanguageRequirements}
              />
            </Tab>
          ))}
        </Tabs>
      </div>
    </section>
  );
}
